/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusecontact2Inputs */

const id_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika Anda memiliki pertanyaan tentang Kebijakan Penggunaan Wajar kami atau percaya bahwa konten apa pun melanggar hak cipta Anda, silakan hubungi kami di:`)
};

const ms_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika anda mempunyai soalan tentang Dasar Penggunaan Adil kami atau percaya mana-mana kandungan melanggar hak cipta anda, sila hubungi kami di:`)
};

const da_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du har spørgsmål om vores Fair Use Politik eller mener at noget indhold krænker din ophavsret, bedes du kontakte os på:`)
};

const de_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie Fragen zu unserer Fair-Use-Richtlinie haben oder glauben, dass Inhalte Ihr Urheberrecht verletzen, kontaktieren Sie uns bitte unter:`)
};

const en_us2_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have questions about our Fair Use Policy or believe any content infringes on your copyright, please contact us at:`)
};

const es_es2_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tienes preguntas sobre nuestra Política de Uso Justo o crees que algún contenido infringe tu derecho de autor, contáctanos en:`)
};

const es_mx2_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tienes preguntas sobre nuestra Política de Uso Justo o crees que algún contenido infringe tu derecho de autor, contáctanos en:`)
};

const fil_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung mayroon kang mga katanungan tungkol sa aming Patakaran sa Patas na Paggamit o naniniwala na ang anumang content ay lumalabag sa iyong copyright, mangyaring makipag-ugnayan sa amin sa:`)
};

const fr_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez des questions sur notre politique d'utilisation équitable ou si vous estimez qu'un contenu enfreint vos droits d'auteur, veuillez nous contacter à :`)
};

const it_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se hai domande sulla nostra Politica di Fair Use o ritieni che qualsiasi contenuto violi il tuo copyright, contattaci all'indirizzo:`)
};

const hu_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha kérdésed van Fair Use irányelvünkkel kapcsolatban, vagy úgy véled, hogy bármely tartalom sérti a szerzői jogodat, kérjük, lépj kapcsolatba velünk a következő címen:`)
};

const nl_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je vragen hebt over ons Fair Use-beleid of van mening bent dat inhoud je auteursrecht schendt, neem dan contact met ons op via:`)
};

const no_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du har spørsmål om våre retningslinjer for rimelig bruk eller mener at noe innhold krenker opphavsretten din, vennligst kontakt oss på:`)
};

const pl_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli masz pytania dotyczące naszej Polityki dozwolonego użytku lub uważasz, że jakakolwiek treść narusza Twoje prawa autorskie, skontaktuj się z nami:`)
};

const pt_br2_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se você tiver dúvidas sobre nossa Política de Uso Justo ou acreditar que algum conteúdo viola seus direitos autorais, entre em contato conosco:`)
};

const pt_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se tiver dúvidas sobre a nossa Política de Uso Justo ou acreditar que algum conteúdo infringe os seus direitos de autor, contacte-nos em:`)
};

const ro_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dacă aveți întrebări despre Politica noastră de utilizare corectă sau considerați că orice conținut vă încalcă drepturile de autor, contactați-ne la:`)
};

const fi_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos sinulla on kysyttävää kohtuullisen käytön käytännöstämme tai uskot jonkin sisällön loukkaavan tekijänoikeuksiasi, ota meihin yhteyttä:`)
};

const sv_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du har frågor om vår policy för skälig användning eller anser att något innehåll kränker din upphovsrätt, kontakta oss på:`)
};

const vi_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu bạn có câu hỏi về Chính sách Sử dụng Hợp lý của chúng tôi hoặc tin rằng bất kỳ nội dung nào vi phạm bản quyền của bạn, vui lòng liên hệ với chúng tôi tại:`)
};

const tr_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adil Kullanım Politikamız hakkında sorularınız varsa veya herhangi bir içeriğin telif hakkınızı ihlal ettiğini düşünüyorsanız, lütfen bizimle şu adresten iletişime geçin:`)
};

const cs_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máte-li dotazy ohledně našich Zásad spravedlivého použití nebo se domníváte, že jakýkoli obsah porušuje vaše autorská práva, kontaktujte nás na:`)
};

const bg_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ако имате въпроси относно нашата Политика за честна употреба или смятате, че някакво съдържание нарушава вашето авторско право, моля, свържете се с нас на:`)
};

const ru_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если у вас есть вопросы о нашей Политике добросовестного использования или вы считаете, что какой-либо контент нарушает ваши авторские права, пожалуйста, свяжитесь с нами по адресу:`)
};

const uk_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Якщо у вас є запитання щодо нашої Політики добросовісного використання або ви вважаєте, що якийсь вміст порушує ваші авторські права, зв'яжіться з нами:`)
};

const ar_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذا كانت لديك أسئلة حول سياسة الاستخدام العادل لدينا أو تعتقد أن أي محتوى ينتهك حقوق الطبع والنشر الخاصة بك، يرجى الاتصال بنا على:`)
};

const hi_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि आपके पास हमारी उचित उपयोग नीति के बारे में प्रश्न हैं या मानते हैं कि कोई सामग्री आपके कॉपीराइट का उल्लंघन करती है, तो कृपया हमसे यहाँ संपर्क करें:`)
};

const th_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากคุณมีคำถามเกี่ยวกับนโยบายการใช้งานโดยชอบของเราหรือเชื่อว่าเนื้อหาใดละเมิดลิขสิทธิ์ของคุณ โปรดติดต่อเราที่:`)
};

const ja_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェアユースポリシーについて質問がある場合、またはコンテンツが著作権を侵害していると思われる場合は、こちらまでご連絡ください：`)
};

const zh_cn2_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您对我们的合理使用政策有疑问，或认为任何内容侵犯了您的版权，请通过以下方式联系我们：`)
};

const zh_hant1_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您對我們的合理使用政策有疑問，或認為任何內容侵犯了您的版權，請透過以下方式聯絡我們：`)
};

const ko_about_fairusecontact2 = /** @type {(inputs: About_Fairusecontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공정 사용 정책에 대해 문의사항이 있거나 콘텐츠가 저작권을 침해한다고 생각되면 다음으로 연락해 주세요:`)
};

/**
* | output |
* | --- |
* | "If you have questions about our Fair Use Policy or believe any content infringes on your copyright, please contact us at:" |
*
* @param {About_Fairusecontact2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusecontact2 = /** @type {((inputs?: About_Fairusecontact2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusecontact2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusecontact2(inputs)
	if (locale === "ms") return ms_about_fairusecontact2(inputs)
	if (locale === "da") return da_about_fairusecontact2(inputs)
	if (locale === "de") return de_about_fairusecontact2(inputs)
	if (locale === "en-US") return en_us2_about_fairusecontact2(inputs)
	if (locale === "es-ES") return es_es2_about_fairusecontact2(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusecontact2(inputs)
	if (locale === "fil") return fil_about_fairusecontact2(inputs)
	if (locale === "fr") return fr_about_fairusecontact2(inputs)
	if (locale === "it") return it_about_fairusecontact2(inputs)
	if (locale === "hu") return hu_about_fairusecontact2(inputs)
	if (locale === "nl") return nl_about_fairusecontact2(inputs)
	if (locale === "no") return no_about_fairusecontact2(inputs)
	if (locale === "pl") return pl_about_fairusecontact2(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusecontact2(inputs)
	if (locale === "pt") return pt_about_fairusecontact2(inputs)
	if (locale === "ro") return ro_about_fairusecontact2(inputs)
	if (locale === "fi") return fi_about_fairusecontact2(inputs)
	if (locale === "sv") return sv_about_fairusecontact2(inputs)
	if (locale === "vi") return vi_about_fairusecontact2(inputs)
	if (locale === "tr") return tr_about_fairusecontact2(inputs)
	if (locale === "cs") return cs_about_fairusecontact2(inputs)
	if (locale === "bg") return bg_about_fairusecontact2(inputs)
	if (locale === "ru") return ru_about_fairusecontact2(inputs)
	if (locale === "uk") return uk_about_fairusecontact2(inputs)
	if (locale === "ar") return ar_about_fairusecontact2(inputs)
	if (locale === "hi") return hi_about_fairusecontact2(inputs)
	if (locale === "th") return th_about_fairusecontact2(inputs)
	if (locale === "ja") return ja_about_fairusecontact2(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusecontact2(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusecontact2(inputs)
	return ko_about_fairusecontact2(inputs)
});
export { about_fairusecontact2 as "about.fairUseContact" }